import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { searchManyInputStyles } from '@core/components/fc-input/base/fc-search-many-input/fc-search-many-input.component';
import { INTERVAL } from '@core/consts';
import { clearEmptyProperties, mapCheckbox, mapIds } from '@core/utils/filters-utils';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Interval } from '@interfaces';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import english from '../i18n/en.json';
import spanish from '../i18n/es.json';
import portuguese from '../i18n/pt.json';

@Component({
  selector: 'filter-recurrences',
  templateUrl: './filter-recurrences.component.html',
  encapsulation: ViewEncapsulation.None
})
export class FilterRecurrencesComponent implements OnInit {
  public filtersForm: FormGroup;
  public intervals: Interval[] = INTERVAL;
  public filterChanged = new BehaviorSubject<any>({ archived: false });
  public desiredStyle: searchManyInputStyles = searchManyInputStyles.Outlined;

  constructor(
    private formBuilder: FormBuilder,
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  ngOnInit(): void {
    const intervals = this.intervals.map(() => new FormControl(false));

    this.filtersForm = this.formBuilder.group({
      intervalIn: new FormArray(intervals),
      segmentId: new FormControl(),
      companyId: new FormControl(),
      locations: new FormControl(),
      maintenanceTypeId: new FormControl(),
      archived: new FormControl(false),
    });

    this.filtersForm.valueChanges.pipe(
      debounceTime(500),
      tap(() => {
        const filters = clearEmptyProperties({
          interval_in: mapCheckbox(this.filtersForm.value.intervalIn, this.intervals, 'value'),
          segmentId_in: this.filtersForm.value.segmentId,
          locationId_in: mapIds(this.filtersForm.value.locations),
          maintenanceTypeId_in: this.filtersForm.value.maintenanceTypeId,
          companyId_in: this.filtersForm.value.companyId,
          archived: this.filtersForm.value.archived
        });

        this.filterChanged.next(filters);
      })
    ).subscribe();
  }

  clearFilters(): void {
    this.filtersForm.patchValue({
      intervalIn: this.intervals.map(() => false),
      segmentId: null,
      locations: null,
      maintenanceTypeId: null,
      companyId: null,
      archived: false,
    });
  }
}
